<template>
    <a id="subject-text-link" @click.stop.prevent="handleClick">
        <p id="subject-text" class="color-primary">{{ cellProps }}</p>
        <label for="text" :title="cellProps"></label>
    </a>

</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: "EmailSubjectCell.vue",
  props: {
    cellProps: {
      type: String,
      required: true
    },
  },
  methods:{
    ...mapActions('email', ["showViewEmail"]),
    handleClick(){
      this.showViewEmail([this.$attrs.row.id]);
    }
  }
}
</script>
<style scoped>
#subject-text {
    margin: 0;
    max-width: 45vw;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
#subject-text:first-letter {
    text-transform: uppercase;
}
</style>
